import { render, staticRenderFns } from "./OrderOptionsBar.vue?vue&type=template&id=3b1a4655"
import script from "./OrderOptionsBar.vue?vue&type=script&lang=js"
export * from "./OrderOptionsBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports